import { Injectable } from '@angular/core';
import { AngularFireMessaging } from '@angular/fire/compat/messaging';
import { FirebaseService } from './firebase.service';
import { PushNotifications, Token } from '@capacitor/push-notifications';
import { RegistrationError } from '@capacitor/push-notifications/dist/esm/definitions';
import { StorageKey, StorageService } from './storage.service';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  constructor(
    private angularFireMessaging: AngularFireMessaging,
    private firebaseService: FirebaseService,
    private storageService: StorageService,
  ) {}

  updateTokenInDb(token: string) {
    this.firebaseService.updateRealtimeDatabase('users/' + this.storageService.get(StorageKey.UUID), { token: token }).then();
  }

  requestPermission() {
    this.angularFireMessaging.requestToken.subscribe((token) => {
      this.updateTokenInDb(token);
    });
  }

  async initPushNotifications() {
    // Request permission to use push notifications
    await Promise.all([
      PushNotifications.requestPermissions().then((result) => {
        console.log('[PushNotifications] Request response: ', result.receive);

        if (result.receive === 'granted') {
          // Register with Apple / Google to receive push via APNS/FCM
          PushNotifications.register().then();
        } else {
          return false;
        }
      }),
      PushNotifications.addListener('registration', (token: Token) => {
        this.firebaseService.updateRealtimeDatabase('users/' + this.storageService.get(StorageKey.UUID), { token: token.value }).then();
        console.log('[PushNotifications] Token received: ', token.value);
      }),
      PushNotifications.addListener('registrationError', (error: RegistrationError) => {
        console.error('[PushNotifications] Failed to register for push notifications: ', error.error);
      }),
      // PushNotifications.addListener('pushNotificationReceived', (notification: PushNotificationSchema) => {
      //   // alert('Push received: ' + JSON.stringify(notification));
      // }),
      // PushNotifications.addListener('pushNotificationActionPerformed', (notification: ActionPerformed) => {
      //   // alert('Push action performed: ' + JSON.stringify(notification));
      // }),
      // PushNotifications.getDeliveredNotifications().then((notifications) => {}),
    ]);
  }
}
